var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('screen',{staticClass:"linked-account",attrs:{"size":"medium"}},[_c('template',{slot:"body"},[_c('h2',[_c('inspire')],1),_c('ui-loader',{attrs:{"loading":_vm.isLoading}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }